import type { AppProps } from 'next/app';
import Router from 'next/router';
import { I18nProvider } from 'next-localization';
import NProgress from 'nprogress';
import { SitecorePageProps } from '@/lib/page-props';
import { useModalManagerFocusManagement, useModalManagerPageLocking } from '@/shared/hooks/modalManager';
import { useInjectCIAMScript } from '@/shared/hooks/useInjectCIAMScript';
// Using bootstrap and nprogress are completely optional.
//  bootstrap is used here to provide a clean layout for samples, without needing extra CSS in the sample app
//  nprogress provides a loading indicator on page/route changes
// Remove these in package.json as well if removed here.
import 'bootstrap/dist/css/bootstrap.css';
import 'nprogress/nprogress.css';
import '@/assets/app.css';
import 'ej_styles/index.scss';

NProgress.configure({ showSpinner: false, trickleSpeed: 100 });

Router.events.on('routeChangeStart', () => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

function App({ Component, pageProps }: AppProps<SitecorePageProps>): JSX.Element {
  // CUSTOMISEDSITECORE - remove calls to the dictionary service
  const { /*dictionary,*/ ...rest } = pageProps;

  useModalManagerPageLocking();
  useModalManagerFocusManagement();
  useInjectCIAMScript();
  return (
    // Use the next-localization (w/ rosetta) library to provide our translation dictionary to the app.
    // Note Next.js does not (currently) provide anything for translation, only i18n routing.
    // If your app is not multilingual, next-localization and references to it can be removed.

    // CUSTOMISEDSITECORE - remove calls to the dictionary service
    <I18nProvider /*lngDict={dictionary}*/ locale={pageProps.locale}>
      <Component {...rest} />
    </I18nProvider>
  );
}

export default App;
